import { NumberInput, NumberInputProps } from "@mantine/core";
import { useDebouncedCallback } from "@mantine/hooks";

export const DECIMAL_PROPS = {
  allowDecimal: true,
  decimalScale: 2,
};

interface CustomNumberInputProps extends NumberInputProps {
  plain?: boolean;
}

const CustomNumberInput = (props: CustomNumberInputProps) => {
  const handleChange = useDebouncedCallback((value: any | undefined) => {
    if (props.onChange) props.onChange!(value);
  }, 250);

  if (props.plain) {
    return (
      <NumberInput
        allowDecimal={false}
        withAsterisk={props.required}
        hideControls={true}
        {...props}
        onChange={handleChange}
      />
    );
  }

  return (
    <NumberInput
      allowDecimal={false}
      withAsterisk={props.required}
      suffix={" CHF"}
      decimalSeparator={"."}
      thousandSeparator={","}
      hideControls={true}
      {...props}
      onChange={handleChange}
      labelProps={{
        size: "sm",
        mb: 2,
      }}
      mb={6}
    />
  );
};

export default CustomNumberInput;
